
import React from 'react';

export const ErrorState: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-64 text-center">
      <div>
        <p className="text-destructive mb-2">Error loading images</p>
        <p className="text-muted-foreground text-sm">Please try again later</p>
      </div>
    </div>
  );
};
